import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Hero=()=> {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black pt-20 pb-12">
      {/* Background Glow */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-dark-700/30 via-black to-black opacity-90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center flex flex-col items-center justify-center w-full">
        {/* Main Brand Visual */}
        <motion.div 
          initial={{opacity: 0, scale: 0.9, y: -20}} 
          animate={{opacity: 1, scale: 1, y: 0}} 
          transition={{duration: 1.2, ease: "easeOut"}}
          className="w-full max-w-2xl lg:max-w-4xl mx-auto mb-2 md:mb-4"
        >
          <img 
            src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1772812705427-blob" 
            alt="BL Performance Logo" 
            className="w-full h-auto object-contain mix-blend-screen drop-shadow-[0_0_40px_rgba(212,175,55,0.2)]"
            style={{WebkitMaskImage: 'linear-gradient(to bottom, black 90%, transparent 100%)'}}
          />
        </motion.div>

        {/* Hero Text */}
        <motion.div 
          initial={{opacity: 0, y: 30}} 
          animate={{opacity: 1, y: 0}} 
          transition={{duration: 0.8, delay: 0.4}}
          className="relative z-20"
        >
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white mb-6 tracking-tighter leading-[0.85] uppercase">
            Costruisci <br className="md:hidden" /> un corpo <br className="md:hidden" /> che <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600">funziona</span>
          </h1>
          
          <p className="text-gray-400 max-w-2xl mx-auto text-lg md:text-xl font-bold mb-10 leading-relaxed tracking-tight">
            Allenamento strutturato per migliorare movimento e prestazione! <br className="hidden md:block" />
            <span className="text-gold-500 font-black tracking-[0.3em] mt-4 inline-block uppercase text-xs">FORZA • VELOCITÀ • CONTROLLO</span>
          </p>

          {/* CTA Buttons - Updated as requested */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6">
            <a 
              href="#contatti" 
              className="w-full md:w-auto px-10 py-5 bg-white text-black hover:bg-gold-500 transition-all duration-300 uppercase tracking-widest font-black text-sm min-w-[240px]"
            >
              Prenota una consulenza
            </a>
            <a 
              href="#percorsi" 
              className="w-full md:w-auto px-10 py-5 border-2 border-white/20 text-white hover:border-gold-500 hover:text-gold-500 transition-all duration-300 uppercase tracking-widest font-black text-sm min-w-[240px]"
            >
              I nostri percorsi
            </a>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce text-white/20">
        <SafeIcon icon={FiIcons.FiArrowDown} className="w-6 h-6" />
      </div>
    </section>
  );
};

export default Hero;